export const HAND_COUNT = 3
export const BINGO_POINTS = 2
